export default {
  computed: {

  },
  methods: {
    getDirectoriosPorContrato(idContrato) {
      // Todos los contactos filtrados por fechas y contrato
      const directoriosPorContratos = this.getContratosDirectorios
        .filter((d) => d.idContrato === idContrato)
        .filter(({ fechaAlta }) => new Date(`${fechaAlta} 00:00:0`) <= new Date(`${this.fechaDelInforme} 00:00:0`))
        .filter(({ fechaBaja }) => fechaBaja === null
        || new Date(`${fechaBaja} 00:00:0`) >= new Date(`${this.fechaDelInforme} 00:00:0`));
      // Obtener tipos de directorios para el contrato
      const tiposDirectorio = directoriosPorContratos.map(({ tipo }) => tipo);
      const tiposDirectorioUnicos = tiposDirectorio
        .filter((item, index) => tiposDirectorio.indexOf(item) === index);

      // contactos para cada tipo por organizaciones
      const directorioPorTipos = tiposDirectorioUnicos.map((t) => {
        // Obtener contactos por tipo
        const directorioTodosPorTipo = directoriosPorContratos
          .filter((item) => item.tipo === t);
        // Obtener organizaciones en cada tipo
        const organizacionPorTipos = directoriosPorContratos
          .map(({ organizacion }) => organizacion);
        const organizacionUnicasPorTipos = organizacionPorTipos
          .filter((item, index) => organizacionPorTipos.indexOf(item) === index);

        const diretorioPorOrganizacion = organizacionUnicasPorTipos.map((o) => ({
          organizacion: o,
          detalles:
          directorioTodosPorTipo.filter((directorio) => directorio.organizacion === o),
        }));
        return ({
          tipo: t,
          directorios: [...diretorioPorOrganizacion.filter((d) => d.detalles.length > 0)],
        });
      });

      return directorioPorTipos;
    },
    async generarPdfDirectorio() {
      const nombreTemplate = 'templateInformeDirectorio';
      const datosContrato = this.formatoObjeto(this.getContrato);

      const datosFecha = this.formatoObjeto({
        fechaDel: this.fechaDelInforme,
        fechaAl: this.fechaAlInforme,
      });
      const fechaTitulo = `del ${datosFecha.fechaDel_texto}`;
      const logo = this.getCliente?.logo || '';

      const directorioContrato = {
        contratista: {
          numero: this.getContrato.numero,
          objeto: datosContrato.objeto,
          razonSocial: this.getContrato.contratista.nombreRazonSocial || '',
        },
        directorio: this.getDirectoriosPorContrato(this.getContrato.id),
      };
      const tipoContrato = this.getContrato?.obras[0].obra.tipo.descripcion || '';

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: false,
            format: 'A3',
            footerTemplate: '',
          },
          nombreTemplate,
        },
        data: {
          tipoContrato,
          directorioContrato,
          fecha: datosFecha,
          fechaTitulo,
          logo,
          numeroInforme: this.numeroInforme,
          footer: '',
        },
      }, `${this.contrato.numero}_Directorio_${this.fechaDelInforme}`);
      this.documentoSeleccionado = null;
    },
  },
};
